import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './SubscribePopup.scss';

// ─── EmailJS config ────────────────────────────────────────────────────────────
const EMAILJS_SERVICE_ID       = 'service_qbg9q1w';   // e.g. 'service_abc123'
const EMAILJS_PUBLIC_KEY       = 'TDL8B44cg1kFhX2WU';   // e.g. 'user_XYZabc...'
const TEMPLATE_SUBSCRIBE_POPUP = 'template_n98pj3m';
// ──────────────────────────────────────────────────────────────────────────────

export default function SubscribePopup({ onClose }) {
  const [email,     setEmail]     = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [status,    setStatus]    = useState(null); // null | 'sending' | 'error'
  const [prefs, setPrefs] = useState({
    daily:        true,
    predictions:  true,
    availability: false,
    weekly:       false,
  });

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));

  const handleSubmit = async () => {
    if (!email.trim()) return;
    setStatus('sending');

    // Build a readable summary of selected preferences
    const prefLabels = {
      daily:        'Daily price updates',
      predictions:  'AI price predictions',
      availability: 'Fuel availability alerts',
      weekly:       'Weekly regional roundup',
    };
    const selectedPrefs = Object.entries(prefs)
      .filter(([, v]) => v)
      .map(([k]) => prefLabels[k])
      .join(', ') || 'None selected';

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        TEMPLATE_SUBSCRIBE_POPUP,
        {
          to_email:     email,
          preferences:  selectedPrefs,
          submitted_at: new Date().toLocaleString('en-GB'),
        },
        EMAILJS_PUBLIC_KEY
      );
      setSubmitted(true);
      setStatus(null);
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="popup-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="popup-box">
        <button className="popup-close" onClick={onClose} aria-label="Close">✕</button>

        {submitted ? (
          <div className="popup-success">
            <span className="popup-success__icon">✓</span>
            <h2>You're in.</h2>
            <p>We'll send daily fuel price updates, AI-powered predictions, and availability alerts straight to your inbox.</p>
          </div>
        ) : (
          <>
            <div className="popup-eyebrow">Free · No spam · Cancel anytime</div>
            <h2 className="popup-title">Stay Ahead of the Pump</h2>
            <p className="popup-desc">
              Get daily fuel price alerts, AI predictions on when prices will drop, and local availability
              updates — straight to your inbox.
            </p>

            <input
              className="popup-input"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            />

            <div className="popup-checkboxes">
              {[
                { key: 'daily',        label: 'Daily price updates' },
                { key: 'predictions',  label: 'AI price predictions' },
                { key: 'availability', label: 'Fuel availability alerts' },
                { key: 'weekly',       label: 'Weekly regional roundup' },
              ].map(({ key, label }) => (
                <label key={key} className="popup-checkbox">
                  <input
                    type="checkbox"
                    checked={prefs[key]}
                    onChange={() => toggle(key)}
                  />
                  {label}
                </label>
              ))}
            </div>

            {status === 'error' && (
              <p className="popup-error">Something went wrong — please try again.</p>
            )}

            <button
              className="popup-btn"
              onClick={handleSubmit}
              disabled={status === 'sending'}
            >
              {status === 'sending' ? 'Subscribing…' : 'Subscribe — It\'s Free'}
            </button>

            <div className="popup-skip">
              <button onClick={onClose}>No thanks, I’ll miss out.</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}